import { MapExtend } from '@agissc/ktag-map';

export interface PrintConfiguration {
  Angle: number;
  CopyrightText: string;
  CustomLegendName?: string;
  Graphics?: any[];
  Layoutsubtitle?: string;
  Layouttitle?: string;
  LegendVisible?: boolean;
  LogoFileName: string;
  MapExtent?: MapExtend;
  MapOnly?: boolean;
  MapOnlyImageType: string;
  MapServices?: MapService[];
  OverviewVisible?: boolean;
  ScalebarVisible: boolean;
}

export interface MapService {
  Id: string;
  LayerType: number;
  LayersInLegend: number[];
  Name: string;
  Opacity: number;
  Url: string;
  Version?: string;
  Visible: boolean;
  VisibleLayers: number[];
}

const copyrightText =
  "Die gedruckten Daten haben nur informativen Charakter. Es können keine rechtlichen Ansprüche irgendwelcher Art geltend gemacht werden.\nBitte beachten Sie auch die Ausführungen zum Kartendienst 'kai_arealstatistik' unter https://www.ag.ch/geoportal/api/v1/mapservices/263/documentation.\nQuelle: Daten des Kantons Aargau, Bundesamt für Landestopografie";

export const DEFAULT_PRINT_PAYLOAD: PrintConfiguration = {
  Angle: 0,
  CopyrightText: copyrightText,
  Graphics: [],
  LogoFileName: 'logo.wmf',
  MapOnlyImageType: 'png',
  ScalebarVisible: true,
};

export interface PrintedItem {
  label: string;
  url: string;
  icon: string;
  expire: Date;
}
